<template>
  <el-popover
    placement="right"
    width="500"
    trigger="click"
    @show="onShowPopover">
    <div class="title">{{ promotionCode }}</div>
    <div style="margin-top: 35px">
      <table border="0"
             cellspacing="0"
             cellpadding="0"
             width="100%"
             class="table-promotion-detail">
        <tr>
          <th width="40%">{{ $t('detail') }}</th>
          <th width="40%">{{ $t('periodOfStay') }}</th>
          <th width="20%">{{ $t('night') }}</th>
        </tr>
        <tr>
          <td width="40%">
            {{promotion.detail}}
          </td>
          <td width="40%">
            <span v-if="promotion.periodOfStayList.length === 0">-</span>
            <div v-for="(periodOfStay, index) of promotion.periodOfStayList" :key="`period-${index}`">
              <span> {{bindPeriodOfStay(periodOfStay.startDate, periodOfStay.endDate)}}</span>
            </div>
          </td>
          <td width="20%">
            <div>{{ $t('min') }}: {{ promotion.minNight }}</div>
            <div>{{ $t('max') }}: {{ promotion.maxNight }}</div>
          </td>
        </tr>
      </table>
    </div>
    <el-tag
      style="cursor: pointer"
      type="success"
      slot="reference">{{ promotionCode }}</el-tag>
  </el-popover>
</template>

<script>
import AlertViewMixin from '@/mixins/alert-view-mixin'
import i18nMessages from '@/translations/SpecialOffer/components/PopupSpecialOfferPromotionDetailComponent.i18n'
import SpecialOfferApi from '@/api/special-offer-api'
import { dateFormat } from '@/helpers/datetime'

export default {
  name: 'PopoverSpecialOfferPromotionDetailComponent',
  mixins: [AlertViewMixin],
  i18n: { messages: i18nMessages },
  props: {
    specialOfferId: {
      type: String,
      default: ''
    },
    promotionId: {
      type: String,
      default: ''
    },
    hotelId: {
      type: String,
      default: ''
    },
    promotionCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      promotion: {
        id: '',
        code: '',
        periodOfStayList: [],
        minNight: 0,
        maxNight: 0
      }
    }
  },
  methods: {
    onShowPopover: async function () {
      this.isLoading = true
      try {
        const data = {
          specialOfferId: this.specialOfferId,
          promotionId: this.promotionId
        }
        this.promotion = await SpecialOfferApi.promotionDetail(data)
      } catch (err) {
        this.alertError(err.message)
      }
    },
    bindPeriodOfStay: function (startDate, endDate) {
      const fromDate = new Date(startDate)
      const toDate = new Date(endDate)

      return `${dateFormat.short(fromDate)} - ${dateFormat.short(toDate)}`
    }
  }
}
</script>
<style scope>
  .title {
    width: 512px;
    height: 31px;
    color: #ffffff;
    vertical-align: middle;
    padding-top: 10px;
    margin-top: -12px;
    padding-left: 12px;
    margin-left: -12px;
    margin-bottom: 10px;
    background: #98ca92;
  }

  .table-promotion-detail td, th {
    text-align: center;
    padding: 10px;
    border-bottom: 1px #ccc solid;
    vertical-align: top;
  }
</style>
